module.exports = __webpack_public_path__ + "static/media/right_mix.c5fabf34.png";